export const TEXTS = {
  button: 'Оформить займ',
  title: 'Сумма и срок займа',
};
